import DOMPurify from "dompurify";
import type { App } from "vue";

/**
 * Directive `v-safe-html` — remplaçant sûr de `v-html`.
 *
 * Assainit le HTML via DOMPurify AVANT injection dans le DOM : retire `<script>`, les handlers
 * inline (`onerror`, `onclick`…), les URI `javascript:`, etc., tout en conservant le formatage
 * riche légitime (p, strong, em, ul/ol/li, a, br, span…). Cf. audit sécurité #4 (XSS stockés).
 *
 * À utiliser PARTOUT où l'on rend du HTML issu de la BDD ou saisi par un utilisateur, à la place
 * de `v-html`.
 */
const sanitize = (value: unknown): string => DOMPurify.sanitize(value == null ? "" : String(value));

export const installSafeHtmlDirective = (app: App): void =>
{
	app.directive("safe-html", {
		mounted: (el: HTMLElement, binding: { value: unknown }): void =>
		{
			el.innerHTML = sanitize(binding.value);
		},
		updated: (el: HTMLElement, binding: { value: unknown }): void =>
		{
			el.innerHTML = sanitize(binding.value);
		},
	});
};
